import { $api } from "@/services/api";
import store from ".";
const state = {
  cartRequesterCounters: {
    draft: 0,
    inProcess: 0,
    history: 0,
  },
};
const getters = {
  cartRequesterCounters: (state) => state.cartRequesterCounters,
};
const mutations = {
  setCartRequesterCounters(state, counters) {
    state.cartRequesterCounters.draft = counters.draft;
    state.cartRequesterCounters.inProcess = counters.inProcess;
    state.cartRequesterCounters.history = counters.history;
  },
};
const actions = {
  async getCartRequesterCounters({ commit }) {
    const draftRes = await $api.m_carts.getByQueryString(
      store.getters.isSpecialUser
        ? `?status[$in][0]=Draft&status[$in][1]=Error&status[$in][2]=Reworked&is_active=true`
        : `?status[$in][0]=Draft&status[$in][1]=Error&status[$in][2]=Reworked&is_active=true&requested_by_user=${store.getters.user.userName}&cost_center_code=${store.getters.selectedPlant.code}`
    );
    const inProcessRes = await $api.m_carts.getByQueryString(
      store.getters.isSpecialUser
        ? `?status[$in][0]=Waiting for PR Approval&status[$in][1]=Pending&is_active=true`
        : `?status[$in][0]=Waiting for PR Approval&status[$in][1]=Pending&is_active=true&requested_by_user=${store.getters.user.userName}`
    );
    const historyRes = await $api.m_carts.getByQueryString(
      store.getters.isSpecialUser
        ? `?status[$in][0]=PR Approved&status[$in][1]=Rejected&status[$in][2]=Cancelled&status[$in][3]=Deleted Draft&status[$in][4]=Cancelled.&is_active=true`
        : `?status[$in][0]=PR Approved&status[$in][1]=Rejected&status[$in][2]=Cancelled&status[$in][3]=Deleted Draft&status[$in][4]=Cancelled.&is_active=true&requested_by_user=${store.getters.user.userName}`
    );
    commit("setCartRequesterCounters", {
      draft: draftRes && draftRes.total ? draftRes.total : 0,
      inProcess: inProcessRes && inProcessRes.total ? inProcessRes.total : 0,
      history: historyRes && historyRes.total ? historyRes.total : 0,
    });
  },
};

export default { state, getters, mutations, actions };
